//Funciones
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../context/AlertContext";
import { GoogleLogin } from "@react-oauth/google";
import axios from "axios";

//Componentes
import Input from "../components/Input";
import Loading from "../animations/Loading";

//CSS
import "../css/Login.css";

function Login({ setIsLoggedIn, setTipoSession }) {
  const URL_API = process.env.REACT_APP_URL_API || "http://localhost:5000";
  const { showAlert } = useAlert();
  const [formData, setData] = useState({ username: "", password: "" });
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  // const responseMessage = (response) => {
  //     console.log(response);
  // };
  // const errorMessage = (error) => {
  //     console.log(error);
  // };

  //Animación
  const [loading, setLoading] = useState(false);
  const handleNavigateToRegister = () => {
    setLoading(true);
    setTimeout(() => {
      navigate("/register");
    }, 1000);
  };

  if (loading) {
    return <Loading />;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...formData, [name]: value });

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const validate = async () => {
    const newErrors = {};

    for (const key in formData) {
      if (!formData[key].trim()) {
        newErrors[key] = `Este campo es obligatorio`;
      }
    }

    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    if (formData.username && !emailRegex.test(formData.username)) {
      newErrors.username = "El correo no es válido";
    }

    return newErrors;
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    const validationErrors = await validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      const response = await axios.post(URL_API + "auth/login", {
        correo: formData.username,
        contraseña: formData.password,
      });

      if (response.data.success) {
        localStorage.setItem("userSession", response.data.user);
        localStorage.setItem("tipoSession", response.data.tipo);
        localStorage.setItem("tokenSession", response.data.token);

        const userSession = localStorage.getItem("userSession");
        const tipoSession = localStorage.getItem("tipoSession");
        const tokenSession = localStorage.getItem("tokenSession");

        setLoading(true);
        showAlert(response.data.message, "success");
        setTimeout(() => {
          if (userSession && tokenSession) {
            setIsLoggedIn(true);
            setTipoSession(tipoSession);
          }
        }, 1000);
      } else {
        showAlert(response.data.message, "error");
      }
    } catch (error) {
      showAlert("Error al conectar con el servidor", "error");
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleGoogleLogin = async (response) => {
    console.log(response);
    try {
      const res = await axios.post(`${URL_API}auth/google/callback`, {
        code: response.credential,
      });

      if (res.data.success) {
        localStorage.setItem("userSession", res.data.user);
        localStorage.setItem("tipoSession", res.data.tipo);
        localStorage.setItem("tokenSession", res.data.token);

        const userSession = localStorage.getItem("userSession");
        const tipoSession = localStorage.getItem("tipoSession");
        const tokenSession = localStorage.getItem("tokenSession");

        setLoading(true);
        showAlert(res.data.message, "success");
        setTimeout(() => {
          if (userSession && tokenSession) {
            setIsLoggedIn(true);
            setTipoSession(tipoSession);
          }
        }, 1000);
      } else {
        showAlert(response.data.message, "error");
      }
    } catch (error) {
      showAlert("Error al conectar con el servidor", "error");
      console.error("Error verifying Google token:", error);
    }
  };

  return (
    <div className="login-container">
      <div className="left-section">
        <img src="/images/logo.png" alt="Logo Teach Track" />
      </div>

      <div className="right-section">
        <form onSubmit={handleLogin} className="login-form">
          <h2>Inicio de Sesión</h2>

          <div className="input-container">
            <label>Correo:</label>
            <Input
              placeholder="Ingresa tu correo"
              name="username"
              type="text"
              value={formData.username}
              onChange={handleChange}
            />
            {errors.username && (
              <p className="error-message">{errors.username}</p>
            )}
          </div>

          <div className="input-container">
            <label>Contraseña:</label>
            <div className="password-container">
              <Input
                placeholder="Ingresa tu contraseña"
                name="password"
                type={showPassword ? "text" : "password"}
                value={formData.password}
                onChange={handleChange}
              />
              <span
                onClick={togglePasswordVisibility}
                className="toggle-password"
              >
                <i
                  className={`fa ${
                    showPassword ? "fa-eye-slash" : "fa-eye"
                  } icon`}
                  onClick={togglePasswordVisibility}
                ></i>
              </span>
            </div>
            {errors.password && (
              <p className="error-message">{errors.password}</p>
            )}
          </div>

          <button type="submit" className="login-button">
            Iniciar Sesión
          </button>

          <GoogleLogin
            onSuccess={handleGoogleLogin}
            onError={(e) => {
              console.log(e);
            }}
          />

          <p className="register-link">
            ¿No tienes una cuenta?{" "}
            <span
              onClick={handleNavigateToRegister}
              style={{
                cursor: "pointer",
                color: "#00bf63",
                textDecoration: "underline",
              }}
            >
              Regístrate
            </span>
          </p>
        </form>

        {/* <GoogleLogin onSuccess={responseMessage} onError={errorMessage} /> */}
      </div>
    </div>
  );
}

export default Login;
